module.exports = __webpack_public_path__ + "img/logo.cc5fa205.png";